<template>
  <div class="border">
    <div :class="{'kne-title' : title}">
      <h3>{{title}}</h3>
      <slot name="header-actions"></slot>
    </div>

    <slot class="text-center" name="pre-body-content">
    </slot>

    <paginate :refreshCurrentPage="false" ref="paginator" name="tableResults" tag="div" :list="tableResults" :per="40" :id="id">
      <div class="table-responsive">
        <table class="table table-hover font-grey mb-0 table-sm">
          <!-- Desktop -->
          <transition-group name="fade" tag="tbody" v-if="!isScreenSmall">
            <!-- Sort -->
            <tr class="bg-darkgrey sort-border" key="sort">
              <th v-if="sortSpacing > 0" :colspan="sortSpacing"></th>
              <th v-for="field in conditionalFields" :key="field.type" class="nowrap text-center py-2" :class="{'sortable' : field.type !== '' && sortable === true}" @click="sortBy(field.type, false)">
                <span v-html="field.text"></span>
                <i v-if="sort.current === field.type" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i>
              </th>
            </tr>
            <!-- Filters -->
            <tr v-if="isShowFilter" key='filter' class="table-element_hover">
              <td v-if="isShowSelectAll" class="pt-2">
                <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
                  <input :value="areAllOrdersSelected" @click="onSelectAllOrders()" type="checkbox" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                </label>
              </td>
              <th v-if="sortSpacing > 0 && isShowSelectAll" :colspan="sortSpacing - 1"></th>
              <th v-if="sortSpacing > 0 && !isShowSelectAll" :colspan="sortSpacing"></th>
              <td v-for="field in conditionalFields" :key="field.type">
                <regular-input
                  v-if="field.type !== '' && field.type !== 'survey'"
                  :value="field.value"
                  :placeholder="field.text"
                  @input="field.value = $event;
                  evaluateFiltering(field.type, $event)"
                />
              </td>
            </tr>

            <!-- List of element -->
            <slot name="body-content-desktop"  :results="paginated('tableResults')"></slot>
          </transition-group>
        </table>
      </div>

      <!-- Mobile -->
      <transition-group style="display: block;" name="fade" tag="tbody" v-if="isScreenSmall">
        <div key="mobile">
          <search-filter
            key="SearchFilter"
            :fields="fields"
            :sort="sort"
            @sortBySearchFilter="(field, bool) => this.sortBy(field, bool)" 
          />
          <!-- List of element -->
          <slot name="body-content-mobile" :results="paginated('tableResults')"></slot>
        </div>
      </transition-group>


    </paginate>
    <paginate-links for="tableResults" :hide-single-page="true" :limit="10"></paginate-links>

    <slot class="text-center" name="post-body-content">
    </slot>

  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import CustomJsonExcel from '../Custom-packages/Custom-JsonExcel.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import SearchFilter from '../../basic-components/SearchFilter.vue'

export default {
  name: 'TableList',
  components: {
    CustomJsonExcel,
    HoverToolTip,
    RegularInput,
    SearchFilter
  },

  data () {
    return {
      paginate: ['tableResults'],
      sort: {
        current: this.initialSort,
        desc: true
      },
      selected: [],
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      tableResults: [],
      areAllOrdersSelected: false
    }
  },

  props: {
    title: {
      type: String,
      required: false
    },
    fields: {
      type: [Array, Object],
      required: true
    },
    arrOfElement: {
      type: Array,
      required: true
    },
    sortSpacing: {
      type: Number,
      required: false
    },
    sortable: {
      type: Boolean,
      required: false,
      default: true
    },
    isShowFilter: {
      type: Boolean,
      required: false
    },
    isShowSelectAll: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: false,
      default: ''
    },
    initialSort: {
      type: String,
      required: false,
      default: '.key'
    }
  },

  created () {
    this.isScreenSmall = window.innerWidth < 500
    this.filteredSearchMethod()
  },

  methods: {
    onSelectAllOrders () {
      if (!this.areAllOrdersSelected) {
        this.paginated('tableResults').forEach(order => {
          this.selected.push(order['.key'])
        })
        this.areAllOrdersSelected = true
      } else {
        this.selected = []
        this.areAllOrdersSelected = false
      }

      this.$emit('updateSelectedOrders', this.selected)
    },

    filteredSearchMethod: _.debounce(function () {
      this.tableResults = []
      let processingCopy = this.arrOfElement.slice()

      processingCopy = this.checkRouteQueryVar(processingCopy)

      this.tableResults = processingCopy.filter((order) => {
        let results = true

        for (let field in this.fields) {
          if (this.fields[field].value !== '') {
            let cleanValue = this.fields[field].value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            let reFirstMatch = new RegExp(cleanValue, 'i') // Match with first value (i)

            if (this.fields[field].type === 'creationDate' || this.fields[field.type] === 'date') {
              let date = this.getDate(this.fields[field].value)
              results = reFirstMatch.test(date)
            } else if (this.fields[field].type === 'status') {
              if (order.status === 'Dispatch') results = reFirstMatch.test(this.$t('Search.status.dispatch'))
              else if (order.status === 'Pick') results = reFirstMatch.test(this.$t('Search.status.pick'))
              else if (order.status === 'Processing') results = reFirstMatch.test(this.$t('Search.status.processing'))
              else if (order.status === 'Attente') results = reFirstMatch.test(this.$t('Search.status.waiting'))
              else if (order.status === 'Transit') results = reFirstMatch.test(this.$t('Search.status.transit'))
              else if (order.status === 'Drop') results = reFirstMatch.test(this.$t('Search.status.drop'))
              else if (order.status === 'Cancel') results = reFirstMatch.test(this.$t('Search.status.canceled'))
              else if (order.status === 'Terminée') results = reFirstMatch.test(this.$t('Search.status.finished'))
              else if (order.status === 'Transférée') results = reFirstMatch.test(this.$t('Search.status.transfered'))
              else if (order.status === 'Reject') results = reFirstMatch.test(this.$t('Search.status.rejected'))
              else if (order.status === 'Inspection') results = reFirstMatch.test(this.$t('Search.status.inspection'))
              else results = false
            } else {
              results = reFirstMatch.test(order[this.fields[field].type])
            }
          }
          if (results === false) break
        }
        return results
      })

      this.tableResults.reverse()
      this.sortBy(this.sort.current, true)
      let paginator = this.$refs.paginator
      let maxPage = Math.ceil(this.tableResults.length / paginator.per)
      if (paginator.currentPage + 1 > maxPage && maxPage !== 0) paginator.goToPage(1)
      this.$emit('updateFilterResults', this.tableResults)
    }, 100),

    checkRouteQueryVar (processingCopy) {
      if (this.$route.query.customView === true || this.$route.query.customView === 'true') {
        // Will filter by source if this.$route.query.source is specified in url
        if (this.$route.query.source) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.source || '').toLowerCase() === this.$route.query.source.toLowerCase()
          })
        }
        // Will filter by reference if this.$route.query.reference is specified in url
        if (this.$route.query.reference) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.numRef || '').toLowerCase() === this.$route.query.reference.toLowerCase()
          })
        }
        // Will filter by vin if this.$route.query.vin is specified in url
        if (this.$route.query.vin) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.vin || '').toLowerCase() === this.$route.query.vin.toLowerCase()
          })
        }
        // Will filter by billing if this.$route.query.billing is specified in url
        if (this.$route.query.billing) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.payerName || '').toLowerCase() === this.$route.query.billing.toLowerCase()
          })
        }
        // Will filter by delivery if this.$route.query.delivery is specified in url
        if (this.$route.query.delivery) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.receiverName || '').toLowerCase() === this.$route.query.delivery.toLowerCase()
          })
        }
        // Will filter by driver if this.$route.query.driver is specified in url
        if (this.$route.query.driver) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.driverName || '').toLowerCase() === this.$route.query.driver.toLowerCase()
          })
        }
        // Will filter by pickup if this.$route.query.pickup is specified in url
        if (this.$route.query.pickup) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.transmitterName || '').toLowerCase() === this.$route.query.pickup.toLowerCase()
          })
        }
        // Will filter by from if this.$route.query.from is specified in url
        if (this.$route.query.from) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate > this.$route.query.from
          })
        }
        // Will filter by to if this.$route.query.to is specified in url
        if (this.$route.query.to) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < this.$route.query.to
          })
        }
        // Will filter by status if this.$route.query.status is specified in url
        if (this.$route.query.status) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.status || '').toLowerCase() === this.$route.query.status.toLowerCase()
          })
        }
        // Will filter by after date if this.$route.query.after is specified in url
        if (this.$route.query.after) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.after, 'days').valueOf()
          })
        }
        // Will filter by before date if this.$route.query.before is specified in url
        if (this.$route.query.before) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.before, 'days').valueOf()
          })
        }
        // Will filter by province of pickup if this.$route.query.provincePick is specified in url
        if (this.$route.query.provincePick) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.transmitterProvince || '').toLowerCase() === this.$route.query.provincePick.toLowerCase()
          })
        }
        // Will filter by province of drop if this.$route.query.provinceDrop is specified in url
        if (this.$route.query.provinceDrop) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.receiverProvince || '').toLowerCase() === this.$route.query.provinceDrop.toLowerCase()
          })
        }
      }

      // Will filter by newNote if this.$route.query.newNote is specified in url
      if (this.$route.query.newNote) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.read === false
        })
      }

      if (this.$route.query.newDate) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.datePromis !== null && entry.datePromis !== '' && entry.datePromis !== undefined
        })
      }

      return processingCopy
    },

    sortBy (criteria, newEntry) {
      if (criteria === '' || !this.sortable) return

      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }

      this.tableResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''

        let A = a[criteria]
        let B = b[criteria]

        if (criteria === 'survey') { // If sorting by 'Survey' etc.
          const arrWithABValues = this.getVehicleTimestamp(A, B)
          A = arrWithABValues[0]
          B = arrWithABValues[1]
        } else if (criteria !== 'creationDate' && criteria !== 'date' && criteria !== '.key' && criteria !== 'phone' && criteria !== 'price') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }

        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    },

    getDate: function (timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    evaluateFiltering (attr, val) {
      this.fields.forEach((element, index) => {
        if (element.type === attr) this.fields[index].value = val
      })

      this.filteredSearchMethod()
      let isAttrDupe = false
      if (val === '') {
        return
      }

      this.searchHistory.find((o, i) => {
        if (o.searchType === attr) {
          let storedDupeTag = this.setSearchedItemTag(attr)
          this.searchHistory[i] = {
            searchType: attr, searchText: val, historyTypeTag: storedDupeTag}
          isAttrDupe = true
          return
        }
      })

      if (!isAttrDupe) {
        this.addSearchedItem(attr, val)
      }
    },

    setSearchedItemTag (attr) {
      let storedTag
      if (attr === '.key') { storedTag = this.$t('OrderCurrent.order') }
      if (attr === 'creationDate') { storedTag = this.$t('OrderCurrent.date') }
      if (attr === 'status') { storedTag = this.$t('OrderCurrent.status') }
      if (attr === 'driverName') { storedTag = this.$t('OrderCurrent.driver') }
      if (attr === 'numRef') { storedTag = this.$t('OrderCurrent.reference') }
      if (attr === 'source') { storedTag = this.$t('OrderCurrent.source') }
      if (attr === 'vin') { storedTag = this.$t('OrderCurrent.VIN') }
      if (attr === 'transmitterName') { storedTag = this.$t('OrderCurrent.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('OrderCurrent.delivery') }
      if (attr === 'payerName') { storedTag = this.$t('OrderCurrent.billing') }
      return storedTag
    },

    addSearchedItem (searchedType, searchedText) {
      let storedTag = this.setSearchedItemTag(searchedType)
      this.searchHistory.push({searchType: searchedType, searchText: searchedText, historyTypeTag: storedTag})
    },

    removeSearchedItem (index, attr) {
      this.searchHistory.splice(index, 1)
      this.evaluateFiltering(attr, '')
    },

    /** Gets the timestamp of when the vehicles are ready to sort them by time on the order table
     * Returns an @array with both values needed
    */
    getVehicleTimestamp (survey1, survey2) {
      let timestamp1 = this.setVehicleTimestamp(survey1)
      let timestamp2 = this.setVehicleTimestamp(survey2)

      let arrWithValuesToCompare = []
      arrWithValuesToCompare.push(timestamp1, timestamp2)

      return arrWithValuesToCompare
    },

    /** Sets that sheeet, if question IDs are changed in KNEQuick, make sure to change it here too D: */
    setVehicleTimestamp (survey) {
      let questionArr = survey[Object.keys(survey)]
      let timestamp = 0

      if (questionArr) {
        let question1P1 = questionArr.find(question => question.id === '1.1')

        if (typeof question1P1 !== 'undefined') {
          timestamp = this.getTimestamp(question1P1.answer)
        } else timestamp = 1
      }

      return timestamp
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    },

    checkSageIdField (mapFields, field, index) {
      if (field.type.toLowerCase() === 'sageid' && !this.isSageOne) {
        let emptyItem = {
          text: '',
          type: '',
          value: ''
        }
        console.log('Spliced')
        mapFields.splice(index, 1, emptyItem) // Remove element at index and replace with an emptyItem for UX purposes.
      }

      return mapFields
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 600
    }, 50)
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    conditionalFields () {
      let mapFields = this.fields

      mapFields.forEach((field, index) => {
        let newFields = this.checkSageIdField(mapFields, field, index)
        mapFields = newFields
      })

      return mapFields
    },

    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },

    isDateRoute () {
      return this.$route.query.newDate
    }
  },

  watch: {
    arrOfElement: function () {
      this.filteredSearchMethod()
    },
    '$route.query': function (val) {
      // console.log(val)
      this.filteredSearchMethod()
    }
  }
}
</script>

<style>
  #action {
    display: flex;
    justify-content: end;
  }
  .sort-border {
    border-top: 2px solid #2c2d2f;
  }
</style>
